import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import flechaAvanzar from "../assets/right-arrow.svg";
import { ROUTES } from "../utils/constants";
import { updateStats } from "../utils/helpers";
import presentacionDfVideo from "../assets/avatares/presentacion-planeta.mp4";
import { useVideoWithSound } from "../hooks/useVideoWithSound";
import "./StartGame.css";

function GameIntroduction() {
	const navigate = useNavigate();
	const game = useSelector((state) => state.game);
	const group = useSelector((state) => state.group);
	const [loading, setLoading] = useState(false);

	const { videoRef } = useVideoWithSound({
		autoPlay: true,
		volume: 0.8,
	});

	const handleStartGame = (e) => {
		e.preventDefault();
		if (loading) return;
		setLoading(true);

		getGameById(game?._id).then((res) => {
			if (res.status === 200) {
				updateStats({
					...group,
					actualScenario: 1,
					time: 0,
					lastVisited: ROUTES.START_GAME,
				});
				navigate(ROUTES.START_GAME2, {
					state: {
						activeScenario: 1,
					},
				});
			} else {
				setLoading(false);
			}
		});
	};

	return (
		<div className="start-game-page start-game-page--welcome">
			<div className="start-game-inner">
				<div className="start-game-grid">
					<div className="start-game-visual">
						<span className="start-game-badge">
							<span className="start-game-badge-dot" aria-hidden />
							Planeta
						</span>
						<div className="start-game-avatar-wrap">
							<div className="start-game-avatar-inner">
								<video
									ref={videoRef}
									autoPlay
									playsInline
									preload="auto"
									aria-label="Presentación visual"
								>
									<source src={presentacionDfVideo} type="video/mp4" />
								</video>
							</div>
						</div>
					</div>
					<div className="start-game-panel">
						<h1 className="start-game-title">
							Misión IA: diseña una adopción responsable y útil dentro de una empresa
						</h1>
						<p className="start-game-lead">
							Una empresa mediana quiere integrar IA en sus procesos. La dirección ha visto que la competencia ya está usando IA y quiere resultados rápidos.
						</p>
						<p className="start-game-lead">
							Pero la situación interna es confusa:<br/>
							<ul>
								<li>algunos departamentos ya usan herramientas de IA sin control</li>
								<li>los datos están dispersos</li>
								<li>legal no tiene criterios claros</li>
								<li>RRHH teme resistencia interna</li>
								<li>marketing quiere usar IA generativa</li>
								<li>operaciones quiere automatizar tareas</li>
								<li>y dirección quiere ROI en pocos meses</li>
							</ul>
						</p>
						<div className="start-game-footer">
							<button
								type="button"
								className="start-game-cta"
								onClick={handleStartGame}
								disabled={loading}
								aria-busy={loading}
							>
								{loading ? (
									<span
										className="start-game-cta-spinner"
										aria-hidden
									/>
								) : (
									<img
										className="start-game-cta-icon"
										src={flechaAvanzar}
										alt=""
									/>
								)}
								{loading ? "Cargando…" : "Continuar"}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default GameIntroduction;
